// extracted by mini-css-extract-plugin
export var wordContainer = "_i6-0";